/**
 * @summary Create a new user and a token simultaneously.
 */

export async function createUserAndToken() {
  
  const endpoint = "https://uts-acsteamsinteropappv2.azurewebsites.net/userACSToken?scope=voip";

  console.log("\n== Create User and Token ==\n");
  
  const response: any = await fetch(endpoint,
    {
      method: "GET",
      headers: {
        "ocp-apim-subscription-key" : "afc8a3fa00dd409fb6de32a44a0c2a35",
        "Content-Type": "application/json",
      }
    }).then((response) => response.json()
  );

  // Create user with default token
  if(response) { 
    console.log("Creating a new user and token... ", response);
  }
  
  return {
    identityid: response?.communicationUserId,
    userToken: response?.token,
    expiresOn: response.expiresOn,
  };
}

